import React, { useState, useEffect, Fragment, useContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import { makeStyles } from '@material-ui/core/styles';
import StripedTable from '../../../../../components/Table/StripedTable';
import SearchField from '../../../../../components/TextFields/SearchField';
import Progressbar from '../../../../../components/Progress/Progressbar';
import axios from '../../../../../api/axios';
import EditState from './EditState';
// import { store } from '../../../../../store';

import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  statesContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const StatesPage = ({ config }) => {
  useTitle('مدیریت استان ها');
  const classes = useStyles();
  // const { state } = useContext(store);
  // const {itemsCountPerPage} = state.Props;
  const thArray = ['نام استان', 'تقسیم بندی', 'ویرایش'];
  const [localStates, setLocalStates] = useState(null);
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState(null);

  const handleEditState = async () => {
    setState(null);
    getStates();
  };

  const handleShowDialog = (state) => {
    setState(state);
  };

  const getStates = async (search = '') => {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/state/paginate/1/100?search=${search}`
      );
      if (data.docs) {
        setLoading(false);
        setLocalStates(data);
      }
    } catch (error) {
      console.error(JSON.stringify(error));
    }
  };

  useEffect(() => {
    getStates();
  }, []);

  return (
    <Fragment>
      {state && <EditState onClose={handleEditState} data={state} />}
      <FullCard title={config.name} category="تنظیمات استان">
        <div className={classes.statesContainer}>
          <SearchField
            fullWidth
            variant="outlined"
            label="جستجو ..."
            doSearch={getStates}
          />
          {loading ? <Progressbar /> : null}
          {localStates && (
            <div className="states">
              <StripedTable
                thArray={thArray}
                tdArray={localStates.docs.map((s) => [
                  s.title,
                  Object.entries(s.directions).length > 0
                    ? s.directions.join('،')
                    : 'هنوز انجام نشده',
                  <IconButton onClick={() => handleShowDialog(s)}>
                    <EditIcon />
                  </IconButton>,
                ])}
              />
            </div>
          )}
        </div>
      </FullCard>
    </Fragment>
  );
};

export default React.memo(StatesPage);
